import { useFormikContext } from 'formik';
import { MenuItem, TextField } from '@material-ui/core';
import React from 'react';

export const ReportSelect = props => {
  const {
    options = [],
    name,
    onSelect,
    label,
    disabled = false,
    labelProperty,
    valueProperty,
  } = props;
  const { values } = useFormikContext();

  return (
    <>
      <TextField
        variant="outlined"
        fullWidth
        select
        name={name}
        value={values[name] || ''}
        onChange={onSelect}
        label={label}
        disabled={disabled}
      >
        {options.map(option => {
          const value = valueProperty ? option[valueProperty] : option.value;
          const label = labelProperty ? option[labelProperty] : option.label;
          return (
            <MenuItem key={value} value={value}>
              {label}
            </MenuItem>
          );
        })}
      </TextField>
    </>
  );
};